import { defineComponent as _defineComponent } from 'vue';
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-c70dff9e"), n = n(), _popScopeId(), n);
const _hoisted_1 = { class: "footer-steps" };
import { computed } from 'vue';
import { useStore } from 'vuex';
export default /*#__PURE__*/ _defineComponent({
    __name: 'AudienceFooterSteps',
    setup(__props) {
        const store = useStore();
        const currentStep = computed(() => store.getters['audienceManager/activeStep']);
        const audienceSteps = computed(() => store.getters['audienceManager/steps']);
        const isStepActive = (stepId) => {
            const isPreviousStepCompleted = stepId < currentStep.value;
            const isCurrentStep = stepId === currentStep.value;
            return isPreviousStepCompleted || isCurrentStep;
        };
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("ul", _hoisted_1, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(audienceSteps.value, (step) => {
                    return (_openBlock(), _createElementBlock("li", {
                        key: step.id,
                        class: _normalizeClass(["footer-steps__item", { 'footer-steps__item--active': isStepActive(step.id) }])
                    }, [
                        _createElementVNode("span", null, _toDisplayString(step.id), 1)
                    ], 2));
                }), 128))
            ]));
        };
    }
});
